
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Designs from './Designs.vue'
import Inspiration from './Inspiration.vue'

const globalValues = namespace('globalValues')

@Component({
  components: {
    Designs,
    Inspiration
  }
})
export default class Popover extends Vue {
  public get modalPopover() {
    return this.$route.query.modal
  }

  @globalValues.Action
  public hidePopover!: () => Promise<boolean>

  @globalValues.Action
  public showAllDesigns!: () => Promise<boolean>

  @globalValues.Action
  public showInspirationIdeas!: () => Promise<boolean>

  get modalTitle(): string {
    switch (this.modalPopover) {
      case 'designs':
        return 'Browse All Designs'
      case 'inspirations':
        return 'Inspiration & Ideas'
    }
    return ''
  }

  get modalComponent(): string {
    switch (this.modalPopover) {
      case 'designs':
        return 'Designs'
      case 'inspirations':
        return 'Inspiration'
    }
    return ''
  }

  get mobileTitle(): string {
    switch (this.modalPopover) {
      case 'designs':
        return 'All Designs'
      case 'inspirations':
        return 'Inspirations'
    }
    return ''
  }
}
